module.exports = __webpack_public_path__ + "img/5.786fb5a9.jpg";